import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { mescRoutes } from './components/mesc/mesc.module';

/**
 * CGP Components
 */
import { LoggedOutComponent } from './logged-out/logged-out.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { phfRoutes } from './components/phf/phf.module';

export const appRoutes: Routes = [
  mescRoutes,
  phfRoutes,
  { path: '', redirectTo: '/PHF', pathMatch: 'full' },
  { path: 'logged-out', component: LoggedOutComponent },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: '**', component: NotFoundComponent, data: { breadcrumb: "404" } },
];

export const panelbarRouting: ModuleWithProviders<RouterModule> = RouterModule.forRoot(appRoutes, { useHash: true });
